import {
  EntityOwnerPicker,
  EntityProcessingStatusPicker,
  EntitySearchTextFilter,
  EntityTagPicker,
  EntityTypePicker,
  OwnerKind,
  UserListPicker,
  WbResponsiveTableToolbar,
} from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { FC } from 'react';

interface Props {
  isSoftwareCatalog: boolean;
  filtersNode?: JSX.Element;
  actionsNode?: JSX.Element;
  kind?: string;
}

export const CatalogTableFilters: FC<Props> = ({
  isSoftwareCatalog,
  filtersNode,
  actionsNode,
  kind,
}) => {
  const { filters, updateFilters } = useEntityList();
  const configApi = useApi(configApiRef);

  const filtersToRender = () => {
    if (filtersNode) return filtersNode;
    else if (isSoftwareCatalog) {
      const ownerKind = Object.values(OwnerKind).includes(kind as OwnerKind)
        ? (kind as OwnerKind)
        : undefined;
      return (
        <>
          <UserListPicker />
          <EntityTagPicker />
          <EntityTypePicker />
          <EntityProcessingStatusPicker />
          {ownerKind && <EntityOwnerPicker kind={ownerKind} />}
        </>
      );
    }
    return (
      <>
        <UserListPicker />
        <EntityTypePicker />
        <EntityOwnerPicker kind={OwnerKind.System} />
      </>
    );
  };

  return (
    <WbResponsiveTableToolbar
      searchProps={{
        value: filters.text?.value,
        onChange: value => {
          updateFilters({ text: new EntitySearchTextFilter(value, configApi) });
        },
      }}
      marginBottom
    >
      <WbResponsiveTableToolbar.Filters>
        {filtersToRender()}
      </WbResponsiveTableToolbar.Filters>
      <WbResponsiveTableToolbar.Actions>
        {actionsNode}
      </WbResponsiveTableToolbar.Actions>
    </WbResponsiveTableToolbar>
  );
};
